export const registerPwa = () => {
  if (!("serviceWorker" in navigator) || !window.isSecureContext) return;
  const register = () => navigator.serviceWorker.register("/service-worker.js", { scope: "/", updateViaCache: "none" })
    .catch(() => console.warn("The offline app shell is not available yet. Normal online use is unchanged."));
  if (document.readyState === "complete") register();
  else window.addEventListener("load", register, { once: true });
};
